import script from "./CoursePage.vue?vue&type=script&setup=true&lang=js"
export * from "./CoursePage.vue?vue&type=script&setup=true&lang=js"

import "./CoursePage.vue?vue&type=style&index=0&id=1dc6ff70&lang=css"

const __exports__ = script;

export default __exports__